import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../../config/axiosApi/axiosApi";
import APIs from "../../Constants/apis";
import showErrorToast, {
  showSuccessToast,
} from "../../components/CustomComponents/toast/toast";
import GridSectionLoader from "../../components/CustomComponents/preLoad/gridSectionLoader";

function SubscriptionInvoiceComplete() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Confirming payment...");

  useEffect(() => {
    let cancelled = false;

    const finalize = async () => {
      const session = searchParams.get("session");
      if (!session) {
        showErrorToast("Missing checkout session");
        navigate("/subscription-invoices", { replace: true });
        return;
      }

      try {
        const response = await axiosInstance.post(
          APIs.POST_FINALIZE_INVOICE_DOJO_CHECKOUT,
          null,
          { params: { sessionId: session } }
        );

        if (cancelled) return;

        if (response.data?.status && response.data.data?.paid) {
          showSuccessToast(
            response.data.message ||
              "Payment successful. Company access has been updated."
          );
          navigate("/subscription-invoices", { replace: true });
          return;
        }

        // Fallback: poll status once
        const statusRes = await axiosInstance.get(
          APIs.GET_INVOICE_DOJO_CHECKOUT_STATUS,
          { params: { sessionId: session } }
        );

        if (cancelled) return;

        if (statusRes.data?.status && statusRes.data.data?.paid) {
          showSuccessToast("Payment successful. Company access has been updated.");
          navigate("/subscription-invoices", { replace: true });
          return;
        }

        setMessage(
          statusRes.data?.message ||
            response.data?.message ||
            "Payment is still processing. Check invoices shortly."
        );
        showErrorToast(
          statusRes.data?.message ||
            response.data?.message ||
            "Payment not completed yet"
        );
        setTimeout(() => {
          navigate("/subscription-invoices", { replace: true });
        }, 2500);
      } catch (err) {
        if (cancelled) return;
        console.error(err);
        showErrorToast(
          err.response?.data?.message || "Failed to confirm payment"
        );
        navigate("/subscription-invoices", { replace: true });
      }
    };

    finalize();
    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  return (
    <div className="container-fluid py-5">
      <div className="text-center">
        <GridSectionLoader />
        <p className="mt-3 text-muted">{message}</p>
      </div>
    </div>
  );
}

export default SubscriptionInvoiceComplete;
